import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Button, Form, H4, Spinner } from "tamagui";
function FormsDemo(props) {
  const [status, setStatus] = useState("off");
  useEffect(() => {
    if (status === "submitting") {
      const timer = setTimeout(() => setStatus("off"), 2e3);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [status]);
  return /* @__PURE__ */ jsxs(
    Form,
    {
      alignItems: "center",
      minWidth: 300,
      space: true,
      onSubmit: () => setStatus("submitting"),
      borderWidth: 1,
      borderRadius: "$4",
      backgroundColor: "$background",
      borderColor: "$borderColor",
      padding: "$8",
      children: [
        /* @__PURE__ */ jsx(H4, { children: status[0].toUpperCase() + status.slice(1) }),
        /* @__PURE__ */ jsx(Form.Trigger, { asChild: true, disabled: status !== "off", children: /* @__PURE__ */ jsx(Button, { icon: status === "submitting" ? () => /* @__PURE__ */ jsx(Spinner, {}) : void 0, children: "Submit" }) })
      ]
    }
  );
}
export {
  FormsDemo
};
//# sourceMappingURL=FormsDemo.js.map
